'use strict';

angular.module('programme')

.directive('carouselComp', function ($window, $timeout)
{
    return {
        restrict: 'A',
        replace: true,
        templateUrl: 'modules/programme/editor-components/carousel/carousel.html',
        controller: 'CarouselCtrl',
        controllerAs: '$ctrl',
        link: function($scope, element)
        {
            var w = angular.element($window);

            var adjustArrowPosition = function()
            {
                var image = element[0].querySelector('.carousel-inner > .active .carousel-comp-slide-asset');
                var controls = element[0].getElementsByClassName('carousel-control');

                if (!image || !controls) {
                    return;
                }

                if (!$scope.data.description) {
                    angular.forEach(controls, function(c)
                    {
                        c.style.top = 'auto';
                    });

                    return;
                }

                angular.forEach(controls, function(c)
                {
                    c.style.top = ((image.offsetHeight / 2) - 20) + 'px';
                });
            };

            element.ready(function()
            {
                $scope.$watch('data', function()
                {
                    adjustArrowPosition();
                }, true);

                w.bind('resize', adjustArrowPosition);

                $timeout(function()
                {
                    adjustArrowPosition();
                }, 500);
            });


            $scope.$watch('activeSlide', function()
            {
                angular.forEach(element.find('video'), function(v)
                {
                    v.pause();
                });
            });

            $scope.$on('$destroy', function() {
                w.off('resize', adjustArrowPosition);
            });
        }
    };
})

.controller('CarouselCtrl', function ($scope)
{
    this.defaultSlide = {
        title: 'Players from West Germany and Colombia walk out at the San Siro for their group game at the 1990 World Cup',
        subTitle: 'Players from West',
        image: [{type: 'image'}],
        video: [{type: "carousel-video"}],
        score: {
            year: 1965,
            line1: 'INTER MILAN',
            score1: 3,
            line2: 'BENFICA',
            score2: 2,
        },
        components: [
            {
                html : "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed at tristique mi. Pellentesque tempor, mi eget imperdiet accumsan, lorem leo imperdiet augue, accumsan tempus erat nisi sed sem. Aliquam lectus eros, rhoncus et nisl eu, pulvinar bibendum mi. Nullam quis risus dui. Nulla gravida hendrerit quam at dignissim. Pellentesque eu dictum libero. Mauris vel lorem eu sem dapibus pretium.",
                tag: "p",
                type: "textblock"
            },
        ],
    };

    $scope.data.video = $scope.data.video || false;
    $scope.data.description = $scope.data.description || false;
    $scope.data.score = $scope.data.score || false;
    $scope.data.subTitle = $scope.data.subTitle || false;
    $scope.data.timerInterval = $scope.data.timerInterval || 0;
    $scope.data.list = $scope.data.list || [];

    $scope.placeholder = 'http://placehold.it/350x400';

    //Legacy..
    angular.forEach($scope.data.list, function(item)
    {
        if (!item.video[0]) {
            return;
        }

        if (item.video[0].type === 'video-player' ) {
            item.video[0].type = 'carousel-video';
        }
    });

    $scope.images = {};

    $scope.activeSlide = 0;

    $scope.selected = null;

    $scope.setSelectedSlide = function(index)
    {
        $scope.selected = $scope.data.list[index];
    };

    $scope.getActiveSlide = function()
    {
        return $scope.data.list.filter(function(slide){
            return slide.active;
        })[0];
    };

    this.$onInit = function ()
    {
        if (!$scope.data.list.length) {
            this.addSlide(true);
        }
    };

    this.addSlide = function ()
    {
        var s = angular.copy(this.defaultSlide);
        $scope.data.list.push(s);

        if ($scope.selected === null) {
            $scope.selected = $scope.data.list[0];
        }
    };

    this.selectSlide = function (slide)
    {
        this.selected = slide;
    };

    $scope.destroySlide = function (slide)
    {
        var index = $scope.data.list.indexOf(slide);
        if (index === -1) {
            return;
        }

        $scope.data.list.splice(index, 1);
    };

    $scope.$on('component:focus', function ($event)
    {
        if ($event.targetScope.item) {
            this.selectSlide($event.targetScope.item);
        }
    }.bind(this));

    this.$onInit();
});
